import { CustomField } from "./customFields";

export interface Cluster {
  createdDate: Date;
  filters: Filter[] | null;
  id: string;
  modifiedDate: Date;
  name: string;
}

export interface Filter {
  operator: Operators | null;
  property: Property;
  value: any;
  expiryDateFilter?: AssetExpiry | null;
  id?: string;
}

export enum Operators {
  is = "is",
  is_not = "is_not",
  is_empty = "is_empty",
  is_not_empty = "is_not_empty",
  contains = "contains",
  expired = "expired",
  not_expired = "not_expired",
  expiring = "expiring",
  has_role = "has_role",
  is_internal = "is_internal",
  is_not_internal = "is_not_internal",
}

export enum ModuleType {
  CONTENT_MAP = "contentMap",
  REPORTS = "reports",
}

export enum PropertyType {
  asset = "asset",
  collection = "collection",
  user = "user",
  user_group = "user_group",
  contact = "contact",
  company = "company",
  title = "title",
  stream = "stream",
  file_type = "file_type",
  tags = "tags",
  group = "group",
  expiry_date = "expiryDate",
  custom_field = "custom_field",
  DEAL_ROOM = "dealRoom"
}

export enum AssetsActionEnum {
  delete_assets = "delete_assets",
  update_assets = "update_assets",
}

export enum FilterActionEnum {
  add_new_filter = "add_new_filter",
  primary_filter = "primary_filter",
  sub_filter = "sub_filter",
  input_value = "input_value",
  expiry_date = "expiry_date",
  delete_filter = "delete_filter",
  none = "none",
}

export interface Property {
  type: PropertyType;
  fieldId?: string;
  item?: CustomField;
}

export enum AssetExpiry {
  one_month = "one_month",
  one_week = "three_months",
  one_day = "one_day",
  custom = "custom",
}

export const TAGS = 'tags';
export const ASSET = 'asset';
export const FILE_TYPE = 'file_type';
export const STREAM = 'stream';
export const TITLE = 'title';
export const GROUP = 'group';
export const EXPIRY_DATE = 'expiryDate';
export const CUSTOM_FIELD = 'custom_field';
export const COLLECTION = 'collection';
export const DEAL_ROOM = 'dealRoom';
export const USER = 'user';
export const USER_GROUP = 'user_group';
export const CONTACT = 'contact';
export const COMPANY = 'company';
export const SHARE = 'share';
export const COLLECTION_SECTION='collection_section';